const geojson = require("./leaflet_map");

var restyleLayer = function(region) {
  geojson.eachLayer(function(featureInstanceLayer) {
    var color = (featureInstanceLayer.feature.properties.GeoRgn === region) ? '#89538a' : 'none';
    var stroke = (featureInstanceLayer.feature.properties.GeoRgn === region) ? '#89538a' : 'none';
      featureInstanceLayer.setStyle({
          fillColor: color,
          opacity: .75,
          color: stroke,
          fillOpacity: 0.4,
          weight: 1
      });
  });
}

module.exports = restyleLayer;
